<div class="summary-container">
    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #sidenav mode="side" [opened]="true" [ngClass]="{'expanded': isExpanded, 'collapsed': !isExpanded}"
                     class="sidenav" disableClose>
            <!-- Sidebar toggle: 'menu_open' collapses the menu, 'menu' expands the icon-only rail -->
            <div class="sidenav-header">
                <button mat-icon-button (click)="toggleSidenav()" class="toggle-btn"
                        [attr.aria-label]="isExpanded ? 'Collapse menu' : 'Expand menu'">
                    <mat-icon>{{ isExpanded ? 'menu_open' : 'menu' }}</mat-icon>
                </button>
            </div>
            <mat-nav-list>
                <app-menu-list-item *ngFor="let menuItem of menuItems" [menuItem]="menuItem" [isRailCollapsed]="!isExpanded" [(selectedTab)]="selectedTab" (selectTab)="selectTab($event)"></app-menu-list-item>
            </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content [style.marginLeft.px]="isExpanded ? 240 : 60" class="content">
            <div class="content-area">
                <div style="display: flex">
                    <app-summary-bar 
                        [(application)]="application"
                        (applicationChange)="onApplicationChanged($event)"
                        [selectedTab]="selectedTab"
                        [(savedDate)]="savedDate"
                        />
                </div>
                <div #contentArea class="scrollable-content">
                    <app-activities
                        [hidden]="selectedTab !== 'activities'"
                        [(application)]="application"
                        [(applicationId)]="applicationId"
                        [(currentUser)]="currentUser"
                        (applicationChange)="onApplicationChanged($event)" />
                    <app-details
                        [hidden]="!selectedTab || !selectedTab.startsWith('details')"
                        [(application)]="application"
                        [currentUser]="currentUser"
                        (applicationChange)="onApplicationChanged($event)"
                        (modelChange)="onModelChanged($event)"
                        [selectedTab]="selectedTab"
                        [(saveDate)]="detailSaveDate"
                        [(cancelDate)]="detailCancelDate"
                        [(editDate)]="detailEditDate"
                        (saved)="onSaved()" />
                    <app-fulfillment
                        [hidden]="selectedTab !== 'fulfillment'"
                        [(application)]="application"
                        (applicationChange)="onApplicationChanged($event)"
                        [(currentUser)]="currentUser"
                        *ngIf="isTabLoaded('fulfillment')" />
                    <app-agreements
                        [hidden]="!selectedTab || !selectedTab.startsWith('agreements')"
                        [(application)]="application"
                        [selectedTab]="selectedTab"
                        (applicationChange)="onApplicationChanged($event)"
                        [(currentUser)]="currentUser" (requestedSideNavChange)="handleMenuChange($event)"
                        *ngIf="isTabLoaded('agreements')" />
                    <app-checklist
                        [hidden]="selectedTab !== 'checklist'"
                        [(application)]="application"
                        [(currentUser)]="currentUser"
                        [(permissions)]="permissions"
                        (applicationChange)="onApplicationChanged($event)"
                        *ngIf="isTabLoaded('checklist')" />
                    <app-financial-evaluation
                        [hidden]="selectedTab !== 'underwriting'"
                        [(application)]="application"
                        [(currentUser)]="currentUser"
                        (applicationChange)="onApplicationChanged($event)"
                        *ngIf="isTabLoaded('underwriting')"></app-financial-evaluation>
                    <app-loancalculator 
                        [hidden]="selectedTab !== 'calculator'"
                        [(application)]="application"
                        [(currentUser)]="currentUser"
                        (applicationChange)="onApplicationChanged($event)"
                        *ngIf="isTabLoaded('calculator')"></app-loancalculator>
                    <app-transunion
                        [hidden]="selectedTab !== 'transunion'"
                        [(application)]="application"
                        [(currentUser)]="currentUser"
                        (applicationChange)="onApplicationChanged($event)"
                        *ngIf="isTabLoaded('transunion')" />
                    <app-old-loan-calculator
                        [hidden]="selectedTab !== 'oldCalculator'"
                        [(application)]="application"
                        [(currentUser)]="currentUser"
                        (applicationChange)="onApplicationChanged($event)"
                        *ngIf="isTabLoaded('oldCalculator')" />
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
